import React from 'react';
import { Link } from 'react-router-dom';

const TopTwo = () => {
    return(
        <>
        <div className="header-top">
            <div className="default-container">
                <div className="clearfix">
                    <div className="top-left">
                        <ul className="header-info-list top-item-m">
                            <li><i className="icon fa fa-envelope"></i><strong>Email:</strong> support@example.com</li>
                            <li><i className="icon fa fa-map-marker"></i><strong>Address:</strong> California, TX 70240</li>
                            <li><i className="icon fa fa-headphones"></i><strong>Phone:</strong> +123 456 7890</li>
                        </ul>
                    </div>
                    <div className="top-right">
                        <div className="button-box-tow">
                            <Link to="contact-us.html" className="o-btn btn-style-seven">Ask For Quote</Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
    )
}

export default TopTwo;